import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ff27747"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "QuickActions__bots" }

import { useLocalStorage } from "@vueuse/core";
import { onUnmounted, onMounted, ref } from "vue";

import { usePermissions } from "@/use/usePermissions";
import { initBridge } from "@/api/interceptors";

import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

import UiCollapse from "@/components/ui/UiCollapse.vue";

import ActiveRequest from "./ActiveRequest.vue";
// import TelegramToken from "./TelegramToken.vue";
import BotToken from "./BotToken.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickActions',
  setup(__props) {

const { isAllow } = usePermissions();
const tg_data = ref<any>(null);
const platform = ref<any>(false);

const expanded = useLocalStorage("expand-quick-actions", true);

async function checkTgData() {
  const result = await initBridge();

  tg_data.value = result;

  platform.value = result.platform !== "unknown";
}

onMounted(async () => {
  await checkTgData();
});

onUnmounted(() => {
  platform.value = false;
});

return (_ctx: any,_cache: any) => {
  return (!platform.value)
    ? (_openBlock(), _createBlock(UiGroup, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), {
        default: _withCtx(() => [
          _createVNode(UiCollapse, {
            modelValue: _unref(expanded),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(expanded) ? (expanded).value = $event : null))
          }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: "Быстрые действия" }, {
                right: _withCtx(() => [
                  _createVNode(UiIcon, {
                    size: 18,
                    class: _normalizeClass([{ 'transform-gpu rotate-180': _unref(expanded) }, "transition duration-200"]),
                    icon: "ChevronDown"
                  }, null, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_unref(isAllow)(`bot`) && !platform.value)
                  ? (_openBlock(), _createBlock(BotToken, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              (_unref(isAllow)('request'))
                ? (_openBlock(), _createBlock(ActiveRequest, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 16))
    : _createCommentVNode("", true)
}
}

})